module.exports = __webpack_public_path__ + "img/faucet.d4aa3594.svg";